import { render, staticRenderFns } from "./messagesList.vue?vue&type=template&id=918e09ea&scoped=true&"
import script from "./messagesList.vue?vue&type=script&lang=js&"
export * from "./messagesList.vue?vue&type=script&lang=js&"
import style0 from "./messagesList.vue?vue&type=style&index=0&id=918e09ea&lang=scss&scoped=true&"
import style1 from "./messagesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918e09ea",
  null
  
)

export default component.exports